<template>
    <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
            <p class="modal-card-title">Connexion</p>
            <button
                    type="button"
                    class="delete"
                    @click="$parent.close()"/>
        </header>
        <section class="modal-card-body">
            <b-field label="Nom d'utilisateur">
                <b-input
                        type="text"
                        v-model="user"
                        placeholder="Votre nom d'utilisateur"
                        required>
                </b-input>
            </b-field>

            <b-field label="Mot de passe">
                <b-input
                        type="password"
                        v-model="pass"
                        password-reveal
                        placeholder="Votre mot de passe"
                        required>
                </b-input>
            </b-field>

        </section>
        <footer class="modal-card-foot">
            <button class="button" type="button" @click="$parent.close()">Annuler</button>
            <button class="button is-primary" @click="login">Se connecter</button>
        </footer>
    </div>
</template>

<script>
    export default {
        name: "Login",
        methods: {
            login() {
                // Test auth
                const loadingComponent = this.$buefy.loading.open({
                        container: null
                })
                this.$axios.post('login',
                    {
                        user: this.user,
                        pass: this.pass
                    }, {})
                    .then((res) => {
                        this.$emit("auth", res.data);
                        loadingComponent.close()
                    })
                .catch((error) => {
                    if (error.response.status === 401 ) {
                        loadingComponent.close()
                        this.$buefy.toast.open({
                            duration: 5000,
                            message: `Mauvais identifiants`,
                            position: 'is-bottom',
                            type: 'is-danger'
                        })
                    }
                });
            },
        },
        data() {
            return {
                user: '',
                pass: '',
            }
        }
    }
</script>

<style scoped>

</style>
